import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {AuthStatus, UserState} from "../../models/StoreModels";
import {User} from "../../models/Models";


const initialState : UserState = {
    authStatus: AuthStatus.Loading,
    login: '',
    role: '',
    id: 0
}

export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        LogIn(state, action: PayloadAction<User>){
            state.authStatus = AuthStatus.Authorized
            state.login = action.payload.login
            state.role = action.payload.role
            state.id = action.payload.id
        },
        LogOut(state){
            state.login = ''
            state.role = ''
            state.id = 0
            state.authStatus = AuthStatus.Unauthorized
        },
        SetAuthStatus(state, action: PayloadAction<AuthStatus>){
            state.authStatus = action.payload
        }
    }
})